import * as React from "react";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import Slider, { Settings as SliderSettings } from "react-slick";

import { Wrapper } from "../../../components";
import { TrackClick } from "../../../hoc";
import "./ProductCarousel.css";

export interface ProductCarouselProps {
  settings: SliderSettings;
  children: JSX.Element[];
  onNext: () => void;
  onPrev: () => void;
  assignRef: (el: Slider) => void;
}

const ProductCarousel = (props: ProductCarouselProps) => (
  <Wrapper>
    <div className="language">
      <button title="English">EN</button>
      <button title="Vietnamese" className="active">
        VN
      </button>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="call-to-action">
          <h2 className="call-to-action__title">Thiết kế hỏa tốc</h2>
          <h1 className="call-to-action__heading">
            Dịch vụ đặt hàng thiết kế trực tuyến
          </h1>
          <hr />
          <ul className="call-to-action__feature">
            <li>Đặt thiết kế trong 5 phút - Nhận sản phẩm trong ngày</li>
            <li>Giải pháp thiết kế cho mọi cá nhân và doanh nghiệp</li>
            <li>Tư vấn thiết kế chuyên nghiệp 24/7</li>
          </ul>
          <TrackClick
            category="landingpage"
            action="Clicked wizard call-to-action"
            render={handleClick => (
              <Link
                onClick={handleClick}
                className="call-to-action__button"
                to="/wizard/step-1"
              >
                Đặt thiết kế ngay >>
              </Link>
            )}
          />
        </div>
      </div>

      <div className="col-md-6">
        <section className="product-carousel">
          {props.children &&
          props.children.length > 0 && (
            <Slider
              className="product-carousel__list"
              ref={props.assignRef}
              {...props.settings}
            >
              {props.children.map((slide, index) => (
                <div key={index}>{slide}</div>
              ))}
            </Slider>
          )}
          <div className="product-carousel__nav">
            <div className="owl-nav">
              <button className="left owl-prev" onClick={props.onPrev}>
                <i className="fa fa-caret-left" />
              </button>
              <button className="right owl-next" onClick={props.onNext}>
                <i className="fa fa-caret-right" />
              </button>
            </div>
            <HashLink
              className="product-carousel__more"
              to="/#products"
              replace
            >
              hoặc xem tất cả sản phẩm
            </HashLink>
          </div>
        </section>
      </div>
    </div>
  </Wrapper>
);

export default ProductCarousel;



// WEBPACK FOOTER //
// ./src/routes/ProductCarousel/components/ProductCarousel.tsx